import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sazka-alert__buttons"
}

import { computed } from "vue";
import AccountModal from "@/account/components/shared/account-modal.vue";
import InfoText from "@/account/components/shared/info-text.vue";
import { sazkaAlertProps } from "../use-sazka-alert";


export default /*@__PURE__*/_defineComponent({
  __name: 'sazka-alert',
  setup(__props) {

const btnClass = computed(() => (sazkaAlertProps.ctaYellow ? "btn-secondary" : "btn-primary"));

const ctaClickHandler = () => {
    if (sazkaAlertProps.ctaFunction) {
        sazkaAlertProps.ctaFunction();
    }

    sazkaAlertProps.isOpen = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AccountModal, {
    modelValue: _unref(sazkaAlertProps).isOpen,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(sazkaAlertProps).isOpen) = $event)),
    class: "sazka-alert"
  }, {
    default: _withCtx(() => [
      _createVNode(InfoText, {
        title: _unref(sazkaAlertProps).title,
        perex: _unref(sazkaAlertProps).text,
        class: "sazka-alert__info"
      }, null, 8, ["title", "perex"]),
      (_unref(sazkaAlertProps).ctaText)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn sazka-alert__button", btnClass.value]),
              onClick: ctaClickHandler
            }, _toDisplayString(_unref(sazkaAlertProps).ctaText), 3)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})